var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dialog"},[_vm._t("default"),_c('div',{staticClass:"footer"},[_c('div',{staticClass:"cancel",on:{"click":function($event){return _vm.$emit("cancel")}}},[_vm._v("取消")]),_c('div',{staticClass:"confirm",on:{"click":function($event){return _vm.$emit("confirm")}}},[_vm._v("确认")])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }